"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterRequest = void 0;
var RegisterRequest = /** @class */ (function () {
    function RegisterRequest() {
    }
    return RegisterRequest;
}());
exports.RegisterRequest = RegisterRequest;
;
//# sourceMappingURL=register.request.js.map